import React from 'react';
import { render } from 'react-dom';
import { Router, Route, Link, browserHistory, IndexRoute, IndexRedirect } from 'react-router';

import AppForm from 'apps/AppForm';
import AppAdmin from 'apps/AppAdmin';
import NotFound from 'components/NotFound';

render(
  <Router history={browserHistory}>
    <Route path="/" component={AppForm} />
    <Route path="/ref/:id" component={AppForm} />
    <Route path="/photo/:unicPhoto" component={AppForm} />
    <Route path="/ref/:id/:id2" component={AppForm} />
    
    <Route path="/admin" component={AppAdmin} />
    <Route path="/admin/ref/" referal={true} component={AppAdmin} />
    <Route path="/admin/specialty/:specialty/" component={AppAdmin} />
    <Route path="/admin/specialty/:specialty/profile/:profile/" component={AppAdmin} />
    <Route path="/admin/specialty/:specialty/profile/:profile/tests" test={true} component={AppAdmin} />
    <Route path="/admin/specialty/:specialty/profile/:profile/statuses" statuses={true} component={AppAdmin} />
    <Route path="/*" component={NotFound} />
  </Router>, document.getElementById('app'));



/** WEBPACK FOOTER **
 ** ./assets/main.jsx
 **/